import { WithNAFallback } from '@design/components/table';

import { formatNumberWithUnit } from '../../utils/utils';
import styles from './PriceCell.module.scss';

interface NumberCellProps {
  value: number | undefined;
  useFallbackDash?: boolean;
  fallbackTooltip?: string;
}

export const PriceCell = ({
  value,
  useFallbackDash,
  fallbackTooltip,
}: NumberCellProps) => {
  const formattedValue = formatNumberWithUnit(value);

  return (
    <span className={styles.priceTableValue}>
      <WithNAFallback
        containerPadding="0 0 0 8px"
        check={formattedValue !== '-'}
        value={formattedValue}
        useFallbackDash={useFallbackDash}
        tooltip={fallbackTooltip}
      />
    </span>
  );
};
